import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import config from "../../config";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Widget from "../../components/Widget/Widget";
import Table from "./components/MembershipTable";
import Modal from "../modals/Modal";
import { debounce } from "lodash";
import SnackbarMessage from "../modals/SnackbarMessage";

// styles
import useStyles from "./styles";

export default function MembershipSection() {
  const classes = useStyles();
  const history = useHistory();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl + 'membership/page/');
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [accumulatedItems, setAccumulatedItems] = useState(0);
  const [itemsOnPage, setItemsOnPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const handleToClose = (event, reason) => {
    if ("clickaway" == reason) return;
    setShowSnackbar(false);
  };

  const delayedHandleChange = debounce(search => {
    if (search != '') {
      setIsSearch(true);
      fetch(config.config[0].baseUrl + 'searchMembershipList/' + search,
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }
      ).then((res) => res.json())
        .then((json) => {
          setFilteredData(json);
        });
    } else {
      setIsSearch(false);
      setFilteredData(allData);
    }
  }, 700);

  const handleChange = (e) => {
    delayedHandleChange(e.target.value.toLowerCase());
  }

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const onNextPage = e => {
    if (currentPage < totalPages) {
      fetch(baseUrl + currentPage,
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setAllData(newData);
            setFilteredData(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
            setAccumulatedItems(accumulatedItems + data.numberOfElements);
            setItemsOnPage(data.numberOfElements);
            setTotalItems(data.totalElements);
          } else {
            setMessageSnackbar("Error al consultar membresías");
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        })
        .catch(error => null);
    }
  }

  const onPreviousPage = e => {
    if (currentPage > 1) {
      fetch(baseUrl + (currentPage - 2),
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setAllData(newData);
            setFilteredData(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
            setAccumulatedItems(accumulatedItems - itemsOnPage);
            setItemsOnPage(data.numberOfElements);
            setTotalItems(data.totalElements);
          } else {
            setMessageSnackbar("Error al consultar membresías");
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        })
        .catch(error => null);
    }
  }

  const onClickRow = (property) => (event) => {
    localStorage.setItem('membershipInfo', property);
    history.push({
      pathname: '/app/membershipInfo',
      state: { id: property }
    });
  };

  const fetchMembership = async () => {
    fetch(baseUrl + 0,
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        const newData = data.content;

        if (newData != null) {
          setAllData(newData);
          setFilteredData(newData);
          setTotalPages(data.totalPages);
          setAccumulatedItems(data.numberOfElements);
          setItemsOnPage(data.numberOfElements);
          setTotalItems(data.totalElements);
          if (data.numberOfElements == 0) {
            setCurrentPage(0);
          }
        } else {
          setTotalPages(0);
          setCurrentPage(0);
          setMessageSnackbar("Error al consultar membresías");
          setErrorSnackbar(true);
          setShowSnackbar(true);
        }
      })
      .catch(error => null);
  }

  useEffect(() => {
    fetchMembership();
  }, []);

  return (
    <>
      <div>
        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}

        <SnackbarMessage
          showSnackbar={showSnackbar}
          messageSnackbar={messageSnackbar}
          handleToClose={handleToClose}
          isError={errorSnackbar}
        />

        <PageTitle title="Membresías" />

        <div className={classes.divHeader} >
          <div className={classes.div} >
            <input
              className={classes.input}
              type="text"
              onChange={(event) => handleChange(event)}
            />
            <div className={classes.divSearch} >
              <Icons.Search classes={{ root: classes.searchIcon }} />
            </div>
          </div>

          <div className={classes.divAddButton} >
            <Icons.Add classes={{ root: classes.searchIcon }}
              onClick={() =>
                history.push('/app/addMembership')
              }
            />
          </div>
        </div>

        <Grid item xs={12}>
          <Widget
            noBodyPadding
            bodyClass={classes.tableWidget}
          >
            <Table
              data={filteredData}
              currentPage={currentPage}
              totalPages={totalPages}
              onPreviousPage={onPreviousPage}
              onNextPage={onNextPage}
              onClick={onClickRow}
              accumulatedItems={accumulatedItems}
              totalItems={totalItems}
              isSearch={isSearch}
            />
          </Widget>
        </Grid>
      </div>
    </>
  );
}
